import Resizer from "react-image-file-resizer";

export const resizeFile = (file: File): Promise<string> =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1000,
      1000,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri as string);
      },
      "base64", // base64, blob, file
    );
  });
